import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NebulaDatepickerHeaderComponent } from './nebula-datepicker-header.component';

@Component({
  selector: 'nebula-datepicker-wrapper',
  templateUrl: './nebula-datepicker.component.html'
})
export class NebulaDatepickerWrapperComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() hasNever: boolean;
  @Input() maxDate: Date;
  @Input() minDate: Date;

  public nebulaDatepickerHeader = NebulaDatepickerHeaderComponent;

  constructor() { }

  ngOnInit() { }

}
